import { HFlow, Icon, Icons, Text, Theme, useStyles, VFlow } from 'bold-ui'
import { isString } from 'lodash'
import React, { CSSProperties } from 'react'

interface IconTextCardProps {
  icon?: Icons
  iconColor?: string
  iconPec?: () => React.ReactNode
  label?: string
  value?: string | React.ReactElement
}

export const IconTextCard = (props: IconTextCardProps) => {
  const { icon, iconColor, iconPec, label, value } = props
  const { classes } = useStyles(createStyles, props)
  return (
    <>
      {value && (
        <HFlow hSpacing={0.5}>
          {icon && <Icon icon={icon} style={{ color: `${iconColor}` }} />}
          {iconPec && <span className={classes.icon}>{iconPec()}</span>}
          <VFlow vSpacing={0}>
            <HFlow>
              <Text component='p'>
                <Text className={classes.title}>{`${label}:`}</Text>
                {isString(value) ? <Text className={classes.content}>{value}</Text> : value}
              </Text>
            </HFlow>
          </VFlow>
        </HFlow>
      )}
    </>
  )
}

export const createStyles = (theme: Theme, { value }: IconTextCardProps) => ({
  title: {
    fontWeight: 'bold',
    marginRight: '0.375rem',
  } as CSSProperties,
  content: {
    [theme.breakpoints.down('lg')]: {
      display: 'block',
    },
  } as CSSProperties,
  icon: {
    flexShrink: 0,
  } as CSSProperties,
})
